<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportMTTRs"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-filter-lot-no" label-cols-sm="4" label-cols-lg="3" label="Lot No " label-for="filter-filter-lot-no" size="sm" :model.sync="filter.filterLotNo" />
						<app-input-combobox-autocomplete :options="filterMachineCodes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine Code " id="filter-" size="sm" :model.sync="filter.filterMachineCode" @input="getFilterMachineCodes" @focus="getFilterMachineCodes" />
						<app-input-datepicker-range  id="fieldset-filter-period-date" label-cols-sm="4" label-cols-lg="3" label="Period Date " size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker-range  id="fieldset-filter-start-date" label-cols-sm="4" label-cols-lg="3" label="Start Date " size="sm" :modelFrom.sync="filter.filterStartDateFrom" :modelTo.sync="filter.filterStartDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						<app-input-datepicker-range  id="fieldset-filter-finish-date" label-cols-sm="4" label-cols-lg="3" label="Finish Date " size="sm" :modelFrom.sync="filter.filterFinishDateFrom" :modelTo.sync="filter.filterFinishDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportMTTRs"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report MTTR</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reportmttr" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportMttrs" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportMttrs.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Tanggal WO" class="table-filter">
							<!-- <b-form-input id="input-wo-date-table" @input="getReportMTTRsWithoutLoading" v-model="filter.woDate" size="sm"></b-form-input> -->
							<app-input-datepicker-range @change="getReportMTTRsWithoutLoading" id="fieldset-filter-period-date" label-cols-sm="4" label-cols-lg="3" label="Period Date " size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						</b-th>
						<b-th stacked-heading="No Lot" class="table-filter">
							<b-form-input id="input-lot-no-table" @input="getReportMTTRsWithoutLoading" v-model="filter.filterLotNo" size="sm"></b-form-input>
						</b-th>
						<!-- <b-th stacked-heading="Standard Time Name" class="table-filter"> -->
							<!-- <b-form-input id="input-standar-time-name-table" @input="getReportMTTRsWithoutLoading" v-model="filter.standarTimeName" size="sm"></b-form-input> -->
						<!-- </b-th> -->
						<b-th stacked-heading="Start Production" class="table-filter">
							<!-- <b-form-input id="input-start-production-table" @input="getReportMTTRsWithoutLoading" v-model="filter.startProduction" size="sm"></b-form-input> -->
							<app-input-datepicker-range @change="getReportMTTRsWithoutLoading" id="fieldset-filter-start-date" label-cols-sm="4" label-cols-lg="3" label="Start Date " size="sm" :modelFrom.sync="filter.filterStartDateFrom" :modelTo.sync="filter.filterStartDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						</b-th>
						<b-th stacked-heading="Finish Production" class="table-filter">
							<!-- <b-form-input id="input-finish-production-table" @input="getReportMTTRsWithoutLoading" v-model="filter.finishProduction" size="sm"></b-form-input> -->
							<app-input-datepicker-range @change="getReportMTTRsWithoutLoading" id="fieldset-filter-finish-date" label-cols-sm="4" label-cols-lg="3" label="Finish Date " size="sm" :modelFrom.sync="filter.filterFinishDateFrom" :modelTo.sync="filter.filterFinishDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						</b-th>
						<b-th stacked-heading="Mesin" class="table-filter">
							<!-- <b-form-input id="input-code-table" @input="getReportMTTRsWithoutLoading" v-model="filter.code" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportMTTRsWithoutLoading" :options="filterMachineCodes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine Code " id="filter-" size="sm" :model.sync="filter.filterMachineCode" @input="getFilterMachineCodes" @focus="getFilterMachineCodes" />
						</b-th>
						<!-- <b-th stacked-heading="Work Order Execution Id" class="table-filter"> -->
							<!-- <b-form-input id="input-woe-id-table" @input="getReportMTTRsWithoutLoading" v-model="filter.woeId" size="sm"></b-form-input> -->
						<!-- </b-th> -->
						<b-th stacked-heading="Trouble Report" class="table-filter">
							<!-- <b-form-input id="input-trouble-report-table" @input="getReportMTTRsWithoutLoading" v-model="filter.troubleReport" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Analisis" class="table-filter">
							<!-- <b-form-input id="input-analisa-dan-penyebab-table" @input="getReportMTTRsWithoutLoading" v-model="filter.analisaDanPenyebab" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Tindakan" class="table-filter">
							<!-- <b-form-input id="input-tindakan-table" @input="getReportMTTRsWithoutLoading" v-model="filter.tindakan" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="EKS/IN" class="table-filter">
							<!-- <b-form-input id="input-eks-in-table" @input="getReportMTTRsWithoutLoading" v-model="filter.eksIn" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="PIC MT" class="table-filter">
							<!-- <b-form-input id="input-pic-table" @input="getReportMTTRsWithoutLoading" v-model="filter.pic" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Call" class="table-filter">
							<!-- <b-form-input id="input-hour-minute-start-table" @input="getReportMTTRsWithoutLoading" v-model="filter.hourMinuteStart" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Finish" class="table-filter">
							<!-- <b-form-input id="input-hour-minute-end-table" @input="getReportMTTRsWithoutLoading" v-model="filter.hourMinuteEnd" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Difference" class="table-filter">
							<!-- <b-form-input id="input-difference-hh-mm-table" @input="getReportMTTRsWithoutLoading" v-model="filter.differenceHhMm" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Total" class="table-filter">
							<!-- <b-form-input id="input-total-minutes-table" @input="getReportMTTRsWithoutLoading" v-model="filter.totalMinutes" size="sm"></b-form-input> -->
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>

					<template v-slot:cell(woDate)="row">
						{{ row.item.woDate | moment("DD-MMM-YYYY") }}
					</template>
					<template v-slot:cell(lotNo)="row">
						<a v-if="row.item.maintenanceHistoryId == null || row.item.maintenanceHistoryId == '' || row.item.maintenanceHistoryId == undefined" @click="() => ( $router.push({ name: 'maintenancehistorycreatereport', params : { woeid: row.item.woeId } }))" class="a-link-detail">
							{{ row.item.lotNo }}
						</a>
						<a v-if="row.item.maintenanceHistoryId != null && row.item.maintenanceHistoryId != '' && row.item.maintenanceHistoryId != undefined" @click="() => ( $router.push({ name: 'maintenancehistorydetailreport', params : { fromreportid: row.item.maintenanceHistoryId } }))" class="a-link-detail">
							{{ row.item.lotNo }}
						</a>
					</template>
					<template v-slot:cell(startProduction)="row">
						{{ row.item.startProduction | moment("DD-MMM-YYYY HH:mm") }}
					</template>
					<template v-slot:cell(finishProduction)="row">
						{{ row.item.finishProduction | moment("DD-MMM-YYYY HH:mm") }}
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-textbox id="fieldset-standar-time-name" label-cols-lg="12"  label="Standard Time Name" label-for="input-standar-time-name" size="sm" :model.sync="row.item.standarTimeName"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-start-production" label-cols-lg="12"  label="Start Production" label-for="input-start-production" size="sm" :model.sync="row.item.startProduction"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-finish-production" label-cols-lg="12"  label="Finish Production" label-for="input-finish-production" size="sm" :model.sync="row.item.finishProduction"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Mesin" label-for="input-code" size="sm" :model.sync="row.item.code"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-woe-id" label-cols-lg="12"  label="Work Order Execution Id" label-for="input-woe-id" size="sm" :model.sync="row.item.woeId"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-trouble-report" label-cols-lg="12"  label="Trouble Report" label-for="input-trouble-report" size="sm" :model.sync="row.item.troubleReport"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-analisa-dan-penyebab" label-cols-lg="12"  label="Analisis" label-for="input-analisa-dan-penyebab" size="sm" :model.sync="row.item.analisaDanPenyebab"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-tindakan" label-cols-lg="12"  label="Tindakan" label-for="input-tindakan" size="sm" :model.sync="row.item.tindakan"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-eks-in" label-cols-lg="12"  label="EKS/IN" label-for="input-eks-in" size="sm" :model.sync="row.item.eksIn"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-pic" label-cols-lg="12"  label="PIC MT" label-for="input-pic" size="sm" :model.sync="row.item.pic"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-hour-minute-start" label-cols-lg="12"  label="Call" label-for="input-hour-minute-start" size="sm" :model.sync="row.item.hourMinuteStart"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-hour-minute-end" label-cols-lg="12"  label="Finish" label-for="input-hour-minute-end" size="sm" :model.sync="row.item.hourMinuteEnd"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-difference-hh-mm" label-cols-lg="12"  label="Difference" label-for="input-difference-hh-mm" size="sm" :model.sync="row.item.differenceHhMm"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-total-minutes" label-cols-lg="12"  label="Total" label-for="input-total-minutes" size="sm" :model.sync="row.item.totalMinutes"   :isEditable="false" :isUpdatable="true" />
						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(reportMttrsPaging != null ? reportMttrsPaging.dataCount : 0)"
									:per-page="(reportMttrsPaging != null ? reportMttrsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
    ::v-deep #table-list-reportmttr.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }
    ::v-deep #table-list-reportmttr.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportMTTR from '@/models/ReportMTTR/ReportMTTR';
import ReportMTTRList from '@/models/ReportMTTR/ReportMTTRList';
import ReportMTTRFilter from '@/filters/ReportMTTR/ReportMTTRFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportMTTR, 
		ReportMTTRList, 
		ReportMTTRFilter, 
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-number d-stack-none"}},
				{"woDate": {}, "class" : "th-wo-date first-child", "label" : "Tanggal WO", key: 'woDate', }, 
				{"lotNo": {}, "class" : "th-lot-no", "label" : "No Lot", key: 'lotNo', }, 
				// {"standarTimeName": {}, "class" : "th-standar-time-name last-child", "label" : "Standard Time Name", key: 'standarTimeName', }, 
				{"startProduction": {}, "class" : "th-start-production d-stack-none", "label" : "Start Production", key: 'startProduction', }, 
				{"finishProduction": {}, "class" : "th-finish-production d-stack-none", "label" : "Finish Production", key: 'finishProduction', }, 
				{"code": {}, "class" : "th-code d-stack-none", "label" : "Mesin", key: 'code', }, 
				// {"woeId": {}, "class" : "th-woe-id d-stack-none", "label" : "Work Order Execution Id", key: 'woeId', }, 
				{"troubleReport": {}, "class" : "th-trouble-report d-stack-none", "label" : "Trouble Report", key: 'troubleReport', }, 
				{"analisaDanPenyebab": {}, "class" : "th-analisa-dan-penyebab d-stack-none", "label" : "Analisis", key: 'analisaDanPenyebab', }, 
				{"tindakan": {}, "class" : "th-tindakan d-stack-none", "label" : "Tindakan", key: 'tindakan', }, 
				{"eksIn": {}, "class" : "th-eks-in d-stack-none", "label" : "EKS/IN", key: 'eksIn', }, 
				{"pic": {}, "class" : "th-pic d-stack-none", "label" : "PIC MT", key: 'pic', }, 
				{"hourMinuteStart": {}, "class" : "th-hour-minute-start d-stack-none", "label" : "Call", key: 'hourMinuteStart', }, 
				{"hourMinuteEnd": {}, "class" : "th-hour-minute-end d-stack-none", "label" : "Finish", key: 'hourMinuteEnd', }, 
				{"differenceHhMm": {}, "class" : "th-difference-hh-mm d-stack-none", "label" : "Difference", key: 'differenceHhMm', }, 
				{"totalMinutes": {}, "class" : "th-total-minutes d-stack-none", "label" : "Total", key: 'totalMinutes', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportMttrs: [],
			reportMttrsPaging: {},
			filterMachineCodes : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,

			showinputpopup: false,
		}
	},	methods : {
		showPopup(item) {
			// create dulu disini
			alert('create disini')
			console.log(item)
			this.showinputpopup = true;
		},
		getReportMTTRs : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportMTTR.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportMttrs = result.data
					this.reportMttrsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportMTTRsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportMTTR.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportMttrs = result.data
					this.reportMttrsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterMachineCodes : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportMTTR.getListCustomUrl(this,'getlistfiltermachinecode' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterMachineCodes = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportMTTRFilter();
			this.getReportMTTRs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportMTTRs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportMTTR.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportMTTR.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportMTTR.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportMTTR.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportMTTRs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportMTTR.deleteMultipleData(this).then(result => {
					this.getReportMTTRs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportMTTRParent = document.getElementById('table-list-reportmttr').parentNode;
			tableReportMTTRParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportMTTRParent.scrollWidth - tableReportMTTRParent.offsetWidth) == Math.ceil(tableReportMTTRParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportMTTRParent = document.getElementById('table-list-reportmttr').parentNode;
			tableReportMTTRParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportMTTRParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportMTTRFilter();
		this.getFilterMachineCodes()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report M T T R"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportMTTRs();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportMTTRs();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportMTTRs();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportMTTRs();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportMTTRs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportMTTR.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportmttrindex") {
					this.getReportMTTRsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_m_t_t_r").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
